import { isDevelopment } from '@/lib/config';

/**
 * Non-interactive corner ribbon pinned to the top-left of the viewport that
 * reads "dev" whenever the app is not running in production (local dev server
 * or the dev environment). Renders nothing in production.
 */
export function EnvBadge() {
  if (!isDevelopment) return null;

  return (
    <div
      role="status"
      aria-label="Environment: dev"
      className="pointer-events-none fixed left-0 top-0 z-[9999] h-[52px] w-[52px] select-none overflow-hidden"
    >
      {/* Triangle: top border painted, right border transparent */}
      <div className="absolute left-0 top-0 h-0 w-0 border-r-[52px] border-t-[52px] border-r-transparent border-t-violet-600" />
      <span className="absolute left-[-20px] top-[9px] w-[72px] -rotate-45 text-center font-mono text-[9px] font-bold uppercase leading-[14px] tracking-widest text-white">
        dev
      </span>
    </div>
  );
}
